import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { LightCourse } from "@domain/lms/course/course";
import { formatTimeAgo } from "@utils/date";
import { desktop, mobile } from "@ui/styles/utils";
import { row, stack } from "@ui/components/layout";

interface CourseCategoryAndDateProps extends React.HTMLAttributes<HTMLDivElement> {
	course: LightCourse;
}
export const CourseCategoryAndDate: React.FC<CourseCategoryAndDateProps> = ({ course, ...htmlProps }) => {
	const { subCategory, category, lastUpdateDate, publishedAt } = course;
	return (
		<Container {...htmlProps}>
			<div>{`${I18n.t("course.infos.subcategory")} ${I18n.t(`category.${subCategory ?? category ?? "OTHERS"}`)}`}</div>
			<div>
				{publishedAt && <div>{I18n.t("course.infos.date_published", { date: formatTimeAgo(publishedAt) })}</div>}
				{publishedAt?.toString() !== lastUpdateDate.toString() && (
					<div>{I18n.t("course.infos.date", { date: formatTimeAgo(lastUpdateDate) })}</div>
				)}
			</div>
		</Container>
	);
};

const Container = styled.div`
	${({ theme }) => theme.textStyles.text};
	font-weight: 500;
	font-style: italic;
	display: flex;
	justify-content: space-between;
	@media ${desktop} {
		${row(10, "space-between")};
	}
	@media ${mobile} {
		${stack(10)};
	}
`;
